/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

/* For api status, used by createAsyncThunk */
export const HTTP_STATUS = Object.freeze({
  PENDING: "PENDING",
  FULFILLED: "FULFILLED",
  REJECTED: "REJECTED",
});

/* For webrtc status */
export const WEBRTC_STATUS = Object.freeze({
	UNINITIALIZED: "UNINITIALIZED",
	ERROR: "ERROR",
	CONNECTED: "CONNECTED",
	PENDING: "PENDING",
})

/* For session status */
export const SESSION_STATUS = Object.freeze({
	UNINITIALIZED: "UNINITIALIZED",
	INVALID: "INVALID",
	VALID: "VALID",
	PENDING: "PENDING",
})

const dummy_device_id = "qwertyuiop";
let vst_endpoint = "http://10.128.34.40:30888";
let ui_server_endpoint = "http://10.128.34.40:30888";
let websocket_endpoint = "ws://10.128.34.40:30888/ws";
let vst_websocket_endpoint = "ws://10.128.34.40:30888/vms/ws"
let auth_server = "https://stg.login.nvidia.com";
let enable_ingress = true;
let enable_countdown = false;
let countdown_value = 90;
let enable_camera = true;
let home_view = "WELCOME_VIEW";
let app_title = "SHANNON'S CAFE";

/* Prefer ENV values if defined, to be used with docker */
if (typeof VST_ENDPOINT !== "undefined") {
  vst_endpoint = VST_ENDPOINT;
}
if (typeof UI_SERVER_ENDPOINT !== "undefined") {
  ui_server_endpoint = UI_SERVER_ENDPOINT;
}
if (typeof WEBSOCKET_ENPOINT !== "undefined") {
  websocket_endpoint = WEBSOCKET_ENPOINT;
}
if (typeof VST_WEBSOCKET_ENPOINT !== "undefined") {
  vst_websocket_endpoint = VST_WEBSOCKET_ENPOINT;
}
if (typeof AUTH_SERVER !== "undefined") {
  auth_server = AUTH_SERVER;
}
if (typeof ENABLE_INGRESS !== "undefined") {
  enable_ingress = (ENABLE_INGRESS === true);
}
if (typeof ENABLE_COUNTDOWN !== "undefined") {
  enable_countdown = (ENABLE_COUNTDOWN === true);
}
if (typeof COUNTDOWN_VALUE !== "undefined") {
  countdown_value = parseInt(COUNTDOWN_VALUE, 10);
}
if (typeof ENABLE_CAMERA !== "undefined") {
  enable_camera = (ENABLE_CAMERA === true);
}
if (typeof HOME_VIEW !== "undefined") {
  home_view = HOME_VIEW;
}
if (typeof APP_TITLE !== "undefined") {
  app_title = APP_TITLE;
}


/* export config */
const config = {
  vstEndpoint: vst_endpoint,
  uiServerEndpoint: ui_server_endpoint,
  websocketEndpoint: websocket_endpoint,
  vstWebsocketEndpoint: vst_websocket_endpoint,
  authServer: auth_server,
  enableEngress: enable_ingress,
  enableCountdown: enable_countdown,
  countdownValue: countdown_value,
  enableCamera: enable_camera,
  homeView: home_view,
  appTitle: app_title,
  useVstApiDirectly: !enable_ingress,
  enableLogs: true,
  sessionTokenRefreshInterval: 15000,
  accessAndIdTokenRefreshInterval: 20000,
  websocketReconnectInterval: 500,
  websocketPingInterval: 15000,
};

export default config;
